// prettier-ignore

export { DEV_ACCOUNT_OSC };

const DEV_ACCOUNT_OSC = {
    OSC_ZBS: [
        /**
         * 프로세스: 신청 -> 심사 -> 수수료 -> 검사 -> (조건부 반출) -> 승인
         * 합동검사 O
         */
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"ZBS_VO003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0017",
            rolenmen: "LPCO Verification Approver",
            rolenm: "LPCO 심사 승인자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_VA001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0017",
            rolenmen: "LPCO Verification Approver",
            rolenm: "LPCO 심사 승인자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_VA002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"ZBS_VA003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"ZBS_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"ZBS_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0009",rolenmen:'LPCO Fee Officer',rolenm:"LPCO 수수료 담당자",isnew:"Y",type:undefined,id:"ZBS_FO003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"ZBS_IP003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZBS_FR001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZBS_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"ZBS_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZBS_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_CGCLA: [
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "CGCLA_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "CGCLA_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "CGCLA_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"CGCLA_VO003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "CGCLA_VA001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "CGCLA_VA002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"CGCLA_VA003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "CGCLA_IP001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "CGCLA_IP002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"CGCLA_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"CGCLA_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "CGCLA_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "CGCLA_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "CGCLA_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "CGCLA_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"CGCLA_IP003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "CGCLA_FR001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "CGCLA_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"CGCLA_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "CGCLA_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_MOBEF: [
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "MOBEF_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "MOBEF_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "MOBEF_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"MOBEF_VO003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MOBEF_VA001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MOBEF_VA002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"MOBEF_VA003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "MOBEF_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "MOBEF_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MOBEF_IP001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MOBEF_IP002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"MOBEF_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"MOBEF_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "MOBEF_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "MOBEF_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"MOBEF_IP003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "최종 승인자",
            isnew: "Y",
            type: undefined,
            id: "MOBEF_FR001",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MOBEF_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"MOBEF_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "MOBEF_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_MTID: [
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "MTID_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "MTID_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "MTID_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"MTID_VO003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MTID_VA001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MTID_VA002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"MTID_VA003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "MTID_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "MTID_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MTID_IP001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MTID_IP002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"MTID_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"MTID_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "MTID_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "MTID_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"MTID_IP003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "최종 승인자",
            isnew: "Y",
            type: undefined,
            id: "MTID_FR001",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "MTID_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"MTID_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "MTID_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_ZFDA: [
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZFDA_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "ZFDA_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "ZFDA_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"ZFDA_VO003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZFDA_VA001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZFDA_VA002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"ZFDA_VA003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZFDA_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZFDA_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZFDA_IP001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZFDA_IP002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"ZFDA_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"ZFDA_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZFDA_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZFDA_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"ZFDA_IP003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZFDA_FR001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZFDA_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"ZFDA_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZFDA_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_POE: [
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "POE_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "POE_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "POE_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"POE_VO003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "POE_VA001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "POE_VA002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"POE_VA003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "POE_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "POE_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "POE_IP001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0007",
        //     rolenmen: "LPCO Inspector",
        //     rolenm: "LPCO 검사자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "POE_IP002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"POE_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"POE_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "POE_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "POE_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"POE_IP003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "최종 승인자",
            isnew: "Y",
            type: undefined,
            id: "POE_FR001",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "POE_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"POE_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "POE_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_ZCRLB: [
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"ZCRLB_VO003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZCRLB_VA001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZCRLB_VA002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"ZCRLB_VA003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"ZCRLB_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"ZCRLB_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"ZCRLB_IP003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "최종 승인자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_FR001",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "ZCRLB_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"ZCRLB_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "ZCRLB_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_PPD: [
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "PPD_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "PPD_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "PPD_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"PPD_VO003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "PPD_VA001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "PPD_VA002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"PPD_VA003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "PPD_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "PPD_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "PPD_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "PPD_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"PPD_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"PPD_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "PPD_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "PPD_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"PPD_IP003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "최종 승인자",
            isnew: "Y",
            type: undefined,
            id: "PPD_FR001",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "PPD_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"PPD_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "PPD_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_DLD: [
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "DLD_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "DLD_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "DLD_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"DLD_VO003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0017",
            rolenmen: "LPCO Verification Approver",
            rolenm: "LPCO 심사 승인자",
            isnew: "Y",
            type: undefined,
            id: "DLD_VA001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0017",
            rolenmen: "LPCO Verification Approver",
            rolenm: "LPCO 심사 승인자",
            isnew: "Y",
            type: undefined,
            id: "DLD_VA002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"DLD_VA003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "DLD_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "DLD_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "DLD_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "DLD_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"DLD_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"DLD_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "DLD_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "DLD_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"DLD_IP003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "최종 승인자",
            isnew: "Y",
            type: undefined,
            id: "DLD_FR001",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "DLD_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"DLD_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "DLD_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_DOF: [
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "DOF_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "DOF_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "DOF_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0006",rolenmen:'LPCO Verifier',rolenm:"LPCO 심사자",isnew:"Y",type:undefined,id:"DOF_VO003",pw:"ADMIN",tin:"101333949"},
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "DOF_VA001",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {
        //     0: "OSC",
        //     role: "auth_osci0017",
        //     rolenmen: "LPCO Verification Approver",
        //     rolenm: "LPCO 심사 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "DOF_VA002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0017",rolenmen:'LPCO Verification Approver',rolenm:"LPCO 심사 승인자",isnew:"Y",type:undefined,id:"DOF_VA003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "DOF_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0009",
            rolenmen: "LPCO Fee Officer",
            rolenm: "LPCO 수수료 담당자",
            isnew: "Y",
            type: undefined,
            id: "DOF_FO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "DOF_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "DOF_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0007",rolenmen:'LPCO Inspector',rolenm:"LPCO 검사자",isnew:"Y",type:undefined,id:"DOF_IP003",pw:"ADMIN",tin:"101333949"},
        // {0:"OSC",role:"auth_osci0008",rolenmen:'LPCO Approver',rolenm:"LPCO 승인자",isnew:"Y",type:undefined,id:"DOF_FR001",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "DOF_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "DOF_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {0:"OSC",role:"auth_osci0011",rolenmen:'Joint Inspection Inspector',rolenm:"합동검사 검사자",isnew:"Y",type:undefined,id:"DOF_IP003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "최종 승인자",
            isnew: "Y",
            type: undefined,
            id: "DOF_FR001",
            pw: "ADMIN",
            tin: "101333949",
        },
        // {
        //     0: "OSC",
        //     role: "auth_osci0008",
        //     rolenmen: "LPCO Approver",
        //     rolenm: "최종 승인자",
        //     isnew: "Y",
        //     type: undefined,
        //     id: "DOF_FR002",
        //     pw: "ADMIN",
        //     tin: "101333949",
        // },
        // {0:"OSC",role:"auth_osci0008",rolenmen:'Joint Inspection Approver',rolenm:"최종 승인자",isnew:"Y",type:undefined,id:"DOF_FR003",pw:"ADMIN",tin:"101333949"},
        {
            0: "OSC",
            role: "auth_osci0021",
            rolenmen: "Collection Officer",
            rolenm: "징수 담당자",
            isnew: "Y",
            type: undefined,
            id: "DOF_FO001",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
    OSC_TBS: [
        /**
         * 프로세스: 신청 -> 심사 -> 수수료 -> 검사 -> (조건부 반출) -> 승인
         * 합동검사 O
         */
        {
            0: "OSC",
            role: "auth_osci0004",
            rolenmen: "LPCO Configuration Manager",
            rolenm: "환경설정 담당자",
            isnew: "Y",
            type: undefined,
            id: "TBS_ADMIN",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_eswo0004",
            rolenmen: "Company Registration Reviewer",
            rolenm: "업체 심사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_eswo0004",
            rolenmen: "Company Registration Reviewer",
            rolenm: "업체 심사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_eswo0004",
            rolenmen: "Company Registration Reviewer",
            rolenm: "업체 심사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_VO003",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_eswo0005",
            rolenmen: "Company Registration Approver",
            rolenm: "업체 승인자",
            isnew: "Y",
            type: undefined,
            id: "TBS_FR001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_VO001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_VO002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0006",
            rolenmen: "LPCO Verifier",
            rolenm: "LPCO 심사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_VO003",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0017",
            rolenmen: "LPCO Verification Approver",
            rolenm: "LPCO 심사 승인자",
            isnew: "Y",
            type: undefined,
            id: "TBS_VA001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0017",
            rolenmen: "LPCO Verification Approver",
            rolenm: "LPCO 심사 승인자",
            isnew: "Y",
            type: undefined,
            id: "TBS_VA002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0017",
            rolenmen: "LPCO Verification Approver",
            rolenm: "LPCO 심사 승인자",
            isnew: "Y",
            type: undefined,
            id: "TBS_VA003",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0007",
            rolenmen: "LPCO Inspector",
            rolenm: "LPCO 검사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_IP003",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "LPCO 승인자",
            isnew: "Y",
            type: undefined,
            id: "TBS_FR001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_IP001",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_IP002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0011",
            rolenmen: "Joint Inspection Inspector",
            rolenm: "합동검사 검사자",
            isnew: "Y",
            type: undefined,
            id: "TBS_IP003",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "합동검사 승인자",
            isnew: "Y",
            type: undefined,
            id: "TBS_FR002",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_osci0008",
            rolenmen: "LPCO Approver",
            rolenm: "합동검사 승인자",
            isnew: "Y",
            type: undefined,
            id: "TBS_FR003",
            pw: "ADMIN",
            tin: "101333949",
        },
        {
            0: "OSC",
            role: "auth_eswo0020",
            rolenmen: "TBS (Oil)",
            rolenm: "TBS (Oil)",
            isnew: "Y",
            type: "TZDL",
            id: "EKIBASATBTZDL",
            pw: "ADMIN",
            tin: "101333949",
        },
    ],
};
